<template>
  <el-row class="aside">
    <el-tabs v-model="filterChosed" class="left-chooser" tab-position="left"> <!--@tab-click="handleClick"-->
      <el-tab-pane name="time">
        <span slot="label">
          <div class="aside-filter-icon"><i class="aside-filter-time"></i></div>
        </span>
      </el-tab-pane>
      <el-tab-pane name="alphabetical">
        <span slot="label">
          <div class="aside-filter-icon aside-filter-icon-bigger"><i class="aside-filter-alphabetical"></i></div>
        </span>
      </el-tab-pane>
      <el-tab-pane name="new">
        <span slot="label">
          <div class="aside-filter-icon"><i class="aside-filter-new"></i></div>
        </span>
      </el-tab-pane>
      <el-tab-pane name="table">
        <span slot="label">
          <div class="aside-filter-icon"><i class="aside-filter-table"></i></div>
        </span>
      </el-tab-pane>
      <el-tab-pane name="canceled">
        <span slot="label">
          <div class="aside-filter-icon"><i class="aside-filter-canceled"></i><span v-if="getNumberResasCancelled > 0"
              class="macaron">{{ getNumberResasCancelled }}</span></div>
        </span>
      </el-tab-pane>
      <el-tab-pane name="marketing">
        <span slot="label">
          <div class="aside-filter-icon"><i class="aside-filter-marketing"></i></div>
        </span>
      </el-tab-pane>
      <div id="resasToPrint" ref="scrollpane" class="el-tab-pane">
        <resa-line v-for="resaH in getResas" :key="resaH.id" v-bind:resa='resaH' />
      </div>
    </el-tabs>
    <transition name="fade">
      <popup-take-resa v-if="isVisiblePopupTakeResa" />
      <popup-create-room v-if="isVisiblePopupCreateRoom" />
    </transition>
  </el-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as resaState from '../../store/types/resa-state'
import { compareTime } from '../../tools/timeTool'
import PopupCreateRoom from '../popups/PopupCreateRoom'
import PopupTakeResa from '../popups/PopupTakeResa'
import ResaLine from '../reservation/ResaLine'

export default {
  name: 'MainLeftSide',
  components: { PopupCreateRoom, ResaLine, PopupTakeResa },
  data() {
    return {
      filterChosed: 'time',
      lastY: 0
    }
  },
  mounted: function () {

  },
  computed: {
    ...mapGetters({
      getCurrentResas: 'newReservations/getCurrentResas',
      getCurrentResasLoading: 'newReservations/getCurrentResasLoading',
      getCurrentResasByState: 'newReservations/getCurrentResasByState',
      getClientByid: 'newClients/getClientByid',
      getCurrentTimestamp: 'calendar/getCurrentTimestamp',
      getSelectedSubService: 'newServices/getSelectedSubService',
      isVisiblePopupTakeResa: 'displayer/isVisiblePopupTakeResa',
      isVisiblePopupCreateRoom: 'displayer/isVisiblePopupCreateRoom',
      getDisplayTableById: 'newRooms/getDisplayTableById',
      getSelectedTables: 'newRooms/getSelectedTables',
      getModEdition: 'newRooms/getModEdition',
      getSelectedRoom: 'newRooms/getSelectedRoom',
      getUser: 'newUsers/getUser'
    }),
    getResas: function () {
      let sortTab = []
      if (!this.getModEdition) {
        let resasByRoom = []
        this.getCurrentResas.forEach((resa) => {
          if ((resa.room === '' || resa.room === this.getSelectedRoom || this.getSelectedRoom === '') &&
            resa.state !== resaState.CANCELLED) resasByRoom.push(resa)
        })
        // sort resas by chosed filter
        if (this.filterChosed === 'time') {
          // 2nd sort alpha
          sortTab = resasByRoom
          sortTab.sort((a, b) => {
            let clientA = this.getClientByid(a.cid)
            let clientB = this.getClientByid(b.cid)
            if (clientA && clientB) {
              let uA = clientA.name.toLowerCase()
              let uB = clientB.name.toLowerCase()
              if (uA < uB) return -1
              if (uA > uB) return 1
            }
            return 0
          })
          // first sort time
          sortTab = resasByRoom
          sortTab.sort(function (a, b) {
            return compareTime(a.hour, b.hour)
          })
        } else if (this.filterChosed === 'alphabetical') {
          // 2nd sort time
          sortTab = resasByRoom
          sortTab.sort(function (a, b) {
            return compareTime(a.hour, b.hour)
          })
          // first sort alpha
          sortTab = resasByRoom
          sortTab.sort((a, b) => {
            let clientA = this.getClientByid(a.cid)
            let clientB = this.getClientByid(b.cid)
            if (clientA && clientB) {
              let uA = clientA.name.toLowerCase()
              let uB = clientB.name.toLowerCase()
              if (uA < uB) return -1
              if (uA > uB) return 1
            }
            return 0
          })
        } else if (this.filterChosed === 'table') {
          sortTab = this.getResasByState(resaState.NEED_TABLE)
        } else if (this.filterChosed === 'new') {
          sortTab = this.getResasByState(resaState.TO_CONFIRM)
        } else if (this.filterChosed === 'canceled') {
          sortTab = this.getResasByState(resaState.CANCELLED)
        } else if (this.filterChosed === 'marketing') {
          // second sort alpha
          sortTab = resasByRoom
          sortTab.sort((a, b) => {
            let clientA = this.getClientByid(a.cid)
            let clientB = this.getClientByid(b.cid)
            if (clientA && clientB) {
              let uA = clientA.name.toLowerCase()
              let uB = clientB.name.toLowerCase()
              if (uA < uB) return -1
              if (uA > uB) return 1
            }
            return 0
          })
          // first sort source
          sortTab = resasByRoom
          sortTab.sort((a, b) => {
            let uA = a.source.toLowerCase()
            let uB = b.source.toLowerCase()
            if (uA < uB) return -1
            if (uA > uB) return 1
            return 0
          })
        }
        // if table(s) selected just show resa link to selected table
        if (this.getSelectedTables.length > 0 && this.getSelectedRoom !== '') {
          let linkedResas = []
          let newSortTab = {}
          // for each tables selected
          this.getSelectedTables.forEach((tId) => {
            let tData = this.getDisplayTableById(tId)
            // if resa linked to table
            if (tData !== undefined && tData.resaId.length > 0) {
              tData.resaId.forEach((resaId) => {
                if (!linkedResas.includes(resaId)) {
                  linkedResas.push(resaId)
                }
                // push resa linked to new tab to display
                Object.entries(sortTab).forEach(([rId, rVal]) => {
                  if (rVal.id === resaId) {
                    newSortTab[rId] = rVal
                  }
                })
              })
            }
          })
          sortTab = newSortTab
        }
        return sortTab
      }
    },
    getNumberResasCancelled: function () {
      return this.getResasByState(resaState.CANCELLED).length
    }
  },
  methods: {
    ...mapActions({
      syncCurrentResas: 'newReservations/syncCurrentResas',
      syncRTCurrentResas: 'newReservations/syncRTCurrentResas'
    }),
    getResasByState: function (rState) {
      let res = this.getCurrentResasByState(rState)
      res.sort(function (a, b) {
        return compareTime(a.hour, b.hour)
      })
      return res
    }
  },
  watch: {
    'getCurrentTimestamp': function (val, oldVal) {
      this.syncRTCurrentResas()
    },
    'getSelectedSubService': function (val, oldVal) {
      this.syncRTCurrentResas()
    }
  }
}
</script>

<style lang="scss">
@use "../../styles/components/layout/aside";
@use "../../styles/vars";

.macaron {
  position: absolute;
  top: 10%;
  left: 55%;
  background-color: var(--color_red);
  height: 20px;
  line-height: 20px;
  width: 20px;
  text-align: center;
  color: white;
  border-radius: 50%;
}
</style>
